import type { AgentSummary } from "Infrastructure/ApiZfp/Schema";

export const getAgentFullName = (agent: AgentSummary): string => `${agent.firstName} ${agent.lastName}`;
